import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=43197230&"
import script from "./UsersPage.vue?vue&type=script&lang=ts&"
export * from "./UsersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports